// Purpose: simple SVG bar chart. Used on the admin dashboard to plot
// audit volume / routing throughput. Hand-rolled to keep the bundle
// slim (no chart.js). Scope per §14 Q10 — ~50 lines.

export interface BarDatum {
  label: string;
  value: number;
}

export interface TimeSeriesBarProps {
  data: BarDatum[];
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export function TimeSeriesBar(props: TimeSeriesBarProps) {
  const { data, width = 320, height = 96, color = '#1d4ed8', className } = props;
  const max = data.reduce((m, d) => Math.max(m, d.value), 0) || 1;
  const pad = { t: 6, r: 6, b: 14, l: 6 };
  const innerW = width - pad.l - pad.r;
  const innerH = height - pad.t - pad.b;
  const barGap = 2;
  const barW =
    data.length > 0 ? Math.max(1, (innerW - barGap * (data.length - 1)) / data.length) : 0;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      role="img"
      aria-label={`bar chart with ${data.length} bars, peak ${max}`}
    >
      {data.map((d, i) => {
        const h = Math.round((d.value / max) * innerH);
        const x = pad.l + i * (barW + barGap);
        const y = pad.t + (innerH - h);
        return (
          <g key={i}>
            <title>{`${d.label}: ${d.value}`}</title>
            <rect x={x} y={y} width={barW} height={h} fill={color} />
          </g>
        );
      })}
    </svg>
  );
}
